export const PAGE_ROUTES = {
  HOME: "/",
  SERVICES: "/services",
  ABOUT: "/about",
  GALLERY: "/gallery",
  CONTACT: "/contact",
  PRIVACY: "/privacy-policy",
};

export const NAV_LINKS = [
  { label: "HOME", to: PAGE_ROUTES.HOME },
  { label: "OUR SERVICES", to: PAGE_ROUTES.SERVICES },
  { label: "ABOUT", to: PAGE_ROUTES.ABOUT },
  { label: "GALLERY", to: PAGE_ROUTES.GALLERY },
  { label: "CONTACT", to: PAGE_ROUTES.CONTACT },
];

export const CONTACT_DETAILS = {
  EMAIL: "foundation@pmskillshouse.co.za",
  ADDRESS: ["34 Arbroath Road", "Bedfordview", "Germiston", "2008"],
  MAP_LINK: "https://www.google.com/maps/search/?api=1&query=34+Arbroath+Road+Bedfordview+2008",
  PHONES: [
    { label: "010 035 0558", link: "tel:+27100350558" },
    { label: "011 615 0527", link: "tel:+27116150527" },
  ],
};

export const LOADING_STATE = {
  NOT_LOADING: 0,
  LOADING: 1,
  LOADED: 2,
  ERROR: 3,
};

export const LS_ITEM = {
  CONTACT_SEND: "ls_1",
};

export const NOTIF_TYPE = {
  STANDARD: 0,
  SUCCESS: 1,
  ERROR: 2,
};
